module.exports = __webpack_public_path__ + "static/media/ico_info_new.4ce3a849.svg";